<template>
  <div style="margin-top: 30px;">
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#userModal" @click="prepareCreate">
      Kullanıcı Ekle
    </button>

    <div class="table-responsive mt-3">
      <table class="table align-middle">
        <thead>
        <tr>
          <th>İsim</th>
          <th>Kullanıcı Adı</th>
          <th>Mail</th>
          <th>İşlemler</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="val in usersData" :key="val.id">
          <td>{{ val.name }}</td>
          <td>{{ val.username }}</td>
          <td>{{ val.email }}</td>
          <td>
            <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#deleteModal" @click="setDeleteId(val.id)">Sil</button>
            &nbsp;
            <button class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#userModal" @click="editUser(val.id)">Düzenle</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Kullanıcı Ekle/Düzenle Modal -->
    <div class="modal fade" id="userModal" tabindex="-1" aria-labelledby="userModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" style="max-width: 600px;">
          <div class="modal-header">
            <h5 class="modal-title" id="userModalLabel">{{ isEditing ? 'Kullanıcı Düzenle' : 'Kullanıcı Ekle' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Email</label>
              <input type="email" class="form-control" v-model="items.email" placeholder="name@example.com" />
            </div>
            <div class="mb-3">
              <label class="form-label">Kullanıcı Adı</label>
              <input type="text" class="form-control" v-model="items.username" placeholder="Kullanıcı Adı" />
            </div>
            <div class="mb-3">
              <label class="form-label">Ad Soyad</label>
              <input type="text" class="form-control" v-model="items.name" placeholder="Ad Soyad" />
            </div>
            <div class="mb-3" v-if="!isEditing">
              <label class="form-label">Şifre</label>
              <input type="password" class="form-control" v-model="items.password" placeholder="Şifre" />
            </div>
            <div class="mb-3" v-if="!isEditing">
              <label class="form-label">Şifre Tekrar</label>
              <input type="password" class="form-control" v-model="rePass" placeholder="Şifre Tekrar" />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" data-bs-dismiss="modal">Vazgeç</button>
            <button class="btn btn-primary" @click="isEditing ? updateUser() : saveUser()">
              {{ isEditing ? 'Güncelle' : 'Kaydet' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Silme Onayı Modal -->
    <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteModalLabel">Silme Onayı</h5>
            <button class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">Bu kullanıcıyı silmek istediğinizden emin misiniz?</div>
          <div class="modal-footer">
            <button class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
            <button class="btn btn-danger" data-bs-dismiss="modal" @click="deleteUser(deleteId)">Evet, Sil</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ts-nocheck
import apiClient from "@/axios";
import * as bootstrap from "bootstrap";

export default {
  name: "Users",
  data() {
    return {
      usersData: [],
      items: {
        id: null,
        name: "",
        username: "",
        email: "",
        password: "",
        role: []
      },
      rePass: null,
      isEditing: false,
      deleteId: null
    };
  },
  created() {
    this.getUserData();
  },
  methods: {
    getUserData() {
      apiClient.get("users").then(res => {
        this.usersData = res.data;
      });
    },
    validateEmail(email) {
      const re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    prepareCreate() {
      this.items = { name: "", username: "", email: "", password: "" };
      this.rePass = null;
      this.isEditing = false;
    },
    editUser(id) {
      apiClient.get(`users/${id}`).then(res => {
        this.items = res.data;
        this.isEditing = true;
      });
    },
    saveUser() {
      if (!this.validateEmail(this.items.email)) {
        alert("Geçerli bir email adresi girin.");
        return;
      }
      if (this.items.password.length < 6) {
        alert("Şifre en az 6 karakter olmalı.");
        return;
      }
      if (this.items.password !== this.rePass) {
        alert("Şifreler eşleşmiyor!");
        return;
      }

      const payload = {
        name: this.items.name,
        username: this.items.username,
        email: this.items.email,
        password: this.items.password,
        role: []
      };

      apiClient.post("/auth/signup", payload).then(() => {
        this.getUserData();
        this.closeModal("userModal");
        this.prepareCreate();
      });
    },
    updateUser() {
      const payload = {
        name: this.items.name,
        username: this.items.username,
        email: this.items.email,
        role: []
      };

      apiClient.put(`/users/${this.items.id}`, payload).then(() => {
        this.getUserData();
        this.isEditing = false;
        this.closeModal("userModal");
      });
    },
    setDeleteId(id) {
      this.deleteId = id;
    },
    deleteUser(id) {
      apiClient.delete(`/users/${id}`).then(() => {
        this.getUserData();
      });
    },
    closeModal(modalId) {
      const modalEl = document.getElementById(modalId);
      const modalInstance = bootstrap.Modal.getOrCreateInstance(modalEl);
      modalInstance.hide();

      // EK TEMİZLİK
      setTimeout(() => {
        document.body.classList.remove('modal-open');
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(el => el.remove());
      }, 300); // animasyon süresi kadar beklet
    }
  }
};
</script>

<style scoped>
</style>
